<div class="card-popover job-popover card d-flex"
[ngClass]="increasePopupOpacity ? 'job-popover-opacity': ''"
*ngIf="Model">
    <div class="text-hide jobComplainId">{{Model.ComplainId}}</div>
    <div class="card-header highlightHeader">
        <div class="d-flex justify-content-between">
            <div class="statusIcon-Standard status-{{Model.CurrentStatus}}"
                title="{{'TITLE.TITLE_CALLSTATUS_'+ Model.CurrentStatus | translate}}"></div>
            <div class="">#{{Model.DisplayCallNo}} {{Model.IsGuestCall ? '(G)': '(S)'}} <span class=""
                    *ngIf="Model.AssignedTo"> - {{Model.AssignToName}}</span></div>
            <button type="button" class="close" aria-label="Close" (click)="onClose()">
                <span aria-hidden="true"><i class="fas fa-times-circle"></i></span>
            </button>
        </div>
    </div>

    <div class="card-title" *ngIf="Mode != _JobPopoverMode.ReadOnly">
        <div class="d-flex justify-content-between border-bottom p-3">
            <div class="d-flex w-auto">
                <ng-container *ngIf="Model.IsControlWithKSV">
                    <button type="button"
                        *ngIf="((Model.CurrentStatus == _CallStatuses.Close && Model.ComplainTypeId != _ComplainType.Query) || Model.CurrentStatus == _CallStatuses.Park) && (CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.CallReopen))"
                        class="btn btn-info mr-2" (click)="onOperation(_JobOperationActions.Reopen)"
                        translate>BTN.BTN_REOPEN</button>
                    <button type="button"
                        *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.CallClose)"
                        class="btn btn-primary mr-2" (click)="onOperation(_JobOperationActions.Close)"
                        [hidden]="Model.CurrentStatus != _CallStatuses.Open && Model.CurrentStatus != _CallStatuses.Park"
                        translate>BTN.BTN_CLOSE</button>
                    <button type="button"
                        *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.CallParking)"
                        class="btn btn-secondary mr-2" (click)="onOperation(_JobOperationActions.Park)"
                        [hidden]="Model.CurrentStatus == _CallStatuses.Close || Model.CurrentStatus == _CallStatuses.Park || Model.Priority == _Priorities.Crisis"
                        translate>BTN.BTN_PARK</button>
                    <button type="button"
                        *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.CallParking)"
                        class="btn btn-secondary mr-2" (click)="onOperation(_JobOperationActions.Park)"
                        [hidden]="Model.CurrentStatus != _CallStatuses.Park || Model.Priority == _Priorities.Crisis"
                        translate>BTN.BTN_REPARK</button>
                    <button type="button"
                        *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.CallReassign)"
                        class="btn btn-outline-secondary mr-2" (click)="onOperation(_JobOperationActions.ReAssign)"
                        [hidden]="Model.CurrentStatus == _CallStatuses.Park || Model.CurrentStatus == _CallStatuses.Close"
                        translate>BTN.BTN_REASSIGN</button>

                </ng-container>

                <ng-container
                    *ngIf="(Model?.IsKMTCategory === false || Model?.IsKMTCategory === 0)
                     && Model.CurrentStatus != _CallStatuses.Close
                     && masterService.CheckActiveLicence_Module(masterService.ActivePropertyID, 'KMT_CORE')">
                    <button type="button" class="btn btn-outline-secondary " (click)="onWorkorder(Model)"
                        translate>BTN.BTN_TO_WORKORDER
                    </button>
                </ng-container>

            </div>
            <div class="d-flex w-auto">
                <div ngbDropdown placement="bottom-right">
                    <button type="button" id="extraoptions" ngbDropdownToggle class="btn btn-outline-secondary"><i
                            class="fas fa-bars"></i></button>
                    <div ngbDropdownMenu aria-labelledby="extraoptions">
                        <a class="dropdown-item"
                            *ngIf="Model.IsControlWithKSV && Model.CurrentStatus == _CallStatuses.Open && CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.CallReset)"
                            href="javascript:{}" (click)="onOperation(_JobOperationActions.Reset)"
                            translate>BTN.BTN_RESET</a>
                        <a class="dropdown-item" *ngIf="Model.IsControlWithKSV" href="javascript:{}"
                            (click)="onOperation(_JobOperationActions.AddRemarks)" translate>BTN.BTN_ADD_REMARK</a>
                        <a class="dropdown-item" href="javascript:{}"
                            *ngIf="Model.ComplainTypeId != 1 && CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.TagStaff)"
                            translate (click)="onTagStaff()">BTN.BTN_TAG_STAFF</a>
                        <a class="dropdown-item" href="javascript:{}"
                            *ngIf="Model.IsControlWithKSV && Model.CurrentStatus == _CallStatuses.Open && Model.AssignedTo != null"
                            translate (click)="onSendMessage()">BTN.BTN_SEND_MESSAGE</a>
                        <a class="dropdown-item"
                            *ngIf="(Model.CurrentStatus == _CallStatuses.Close && Model.IsGuestCall == true) && CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.CallGSRAudit)"
                            href="javascript:{}" (click)="gsrAudit.Open(Model, _Modules.NoService)"
                            translate>BTN.BTN_GSR_AUDIT</a>
                        <a class="dropdown-item"
                            *ngIf="CheckActiveLicence_Module(Model.PropertyId,'TTN_GLIT') && CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.GlitchRegistration) && CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.CopyToGlitch)"
                            href="javascript:{}" (click)="onCopyToGlitch()" translate>BTN.BTN_COPY_TO_GLITCH</a>
                        <a class="dropdown-item"
                            *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.CallPrinting)"
                            href="/Pages/ComplaintPrint?ComplainID={{Model.ComplainId}}" target="_blank"
                            translate>BTN.BTN_PRINT</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card-body container-fluid flex-fill">
        <div class="section-scroll">
            <div class="subSection">
                <div class="row">
                    <div class="col-4"><span class="lblDisplay"
                            translate>LBL.PRIORITY</span><br />{{Model.PriorityDescription}}</div>
                    <div class="col-8">
                        <div [hidden]="Model.CurrentStatus != _CallStatuses.Park">
                            <span class="lblDisplay" translate>LBL.PARK_REOPEN_TIME</span><br />{{Model.ParkReopenTime |
                            amDateFormat: DateFormat}}
                        </div>

                        <div [hidden]="Model.CurrentStatus != _CallStatuses.Close">
                            <span class="lblDisplay" translate>LBL.CLOSE_TIME</span><br />{{Model.ClosedAt |
                            amDateFormat: DateFormat}}
                            <br />
                            <span class="lblDisplay" translate>LBL.CLOSE_STATS</span>
                            <br /><span class="font-weight-bold"
                                [ngClass]="Model.TimeTakenVariance > 0 ? 'text-danger' : 'text-success'">{{Model.TimeTakenVarianceText}}</span>
                            (days:hours:mins)
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4"><span class="lblDisplay"
                            translate>LBL.ESCALATION_LEVEL</span><br />{{Model.CurrEscLevel}}</div>
                    <div class="col-8"><span class="lblDisplay"
                            translate>LBL.FIRST_ESCALATION_LEVEL</span><br />{{Model.FirstEscalationTime | amDateFormat:
                        DateFormat}}</div>
                </div>
            </div>

            <div class="subSection">
                <div class="row">
                    <div class="col-4"><span class="lblDisplay"
                            translate>LBL.PROPERTY_CODE</span><br />{{Model.PropertyCode}}</div>
                    <div class="col-8"><span class="lblDisplay"
                            translate>LBL.PROPERTY_NAME</span><br />{{Model.PropertyName}}</div>
                </div>
                <div class="row">
                    <div class="col-4"><span class="lblDisplay"
                            translate>LBL.LOCATION</span><br />{{Model.LocationName}}</div>
                    <div class="col-8">
                        <span class="lblDisplay" translate>LBL.SECTION</span><br />{{Model.SectionName}}
                        <span *ngIf="Model.ZoneName">({{Model.ZoneName}})</span>
                    </div>
                </div>
            </div>

            <div class="subSection">
                <div class="row">
                    <div class="col-4"><span class="lblDisplay"
                            translate>LBL.CATEGORY</span><br />{{Model.CategoryDescription}}</div>
                    <div class="col-8">
                        <span class="lblDisplay" translate>LBL.CALL_DESC</span><br />
                        <i *ngIf="!Model.IsControlWithKSV" class="text-danger kmt-icons kmt-icon-construction"></i>
                        {{Model.CallDescription}}
                    </div>
                </div>

                <div class="row">
                    <div class="col-4"><span class="lblDisplay" translate>LBL.CALL_TYPE</span><br /><span
                            translate>LBL.COMPLAINTYPE_{{Model.ComplainTypeId}}</span></div>
                    <div class="col-8"><span class="lblDisplay"
                            translate>LBL.DEPARTMENT</span><br />{{Model.DepartmentName}}</div>
                </div>
            </div>

            <div class="subSection" [hidden]="Model.IsGuestCall == false">
                <div class="row">
                    <div class="col-4"><span class="lblDisplay" translate>LBL.GUEST_CALL</span><br />{{Model.IsGuestCall
                        ? 'Yes' : 'No'}}</div>
                    <div class="col-8"><span class="lblDisplay"
                            translate>LBL.GUEST_NAME</span><br />{{Model.RequestedByGuestName}}</div>
                </div>

                <div class="row">
                    <div class="col-4"><span class="lblDisplay" translate>LBL.AVG_GSR</span><br />{{Model.AvgGSR}}</div>
                    <div class="col-8"><span class="lblDisplay" translate>LBL.VIP</span><br />{{Model.Vip}}</div>
                </div>
            </div>

            <div class="subSection">
                <div class="row">
                    <div class="col-4"><span class="lblDisplay" translate>LBL.TIME_IN</span><br />{{Model.RegisteredAt |
                        amDateFormat: DateFormat}}</div>
                    <div class="col-8">
                        <span class="lblDisplay"><span translate>LBL.MRT</span> / <span
                                translate>LBL.CALCULATED_FINISH_DATE</span></span>
                        <div><span class="d-inline-block mr-4">{{Model.MRT}} {{'LBL.MINUTES' | translate}}</span> <span
                                class="d-inline-block">{{Model.CalculatedFinishDate | amDateFormat: DateFormat}}</span>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4"><span class="lblDisplay" translate>LBL.LAST_UPDATE</span><br />{{Model.LastUpdate
                        | amDateFormat: DateFormat}}</div>
                    <div class="col-8"><span class="lblDisplay"
                            translate>LBL.ASSIGN_TO</span><br />{{Model.AssignToName}}</div>
                </div>

                <div class="row">
                    <div class="col-4"><span class="lblDisplay"
                            translate>LBL.REPORTED_BY_STAFF</span><br />{{Model.RequestedByStaffName}}</div>
                    <div class="col-8"><span class="lblDisplay" translate>LBL.LOGGER</span><br />{{Model.LoggedByName}}
                    </div>
                </div>

                <div class="row" *ngIf="Model.ExternalId || Model.ExternalContainerId">
                    <div class="col-4"><span class="lblDisplay"
                            translate>LBL.TENANTNAME</span><br />{{Model.ExternalContainerName}}</div>
                    <div class="col-8"><span class="lblDisplay"
                            translate>LBL.TENANTUSER</span><br />{{Model.ExternalCreatedByName}}</div>
                </div>
            </div>

            <div class="subSection" *ngIf="Model.TagStaff">
                <div class="row">
                    <div class="col"><span class="lblDisplay" translate>LBL.TAGGED_STAFF</span><br />{{Model.TagStaff}}
                    </div>
                </div>
            </div>

            <div class="subSection" *ngIf="Model.Reason || Model.LastActionRemarks">
                <div class="row" *ngIf="Model.Reason">
                    <div class="col"><span class="lblDisplay linebreak"
                            translate>LBL.REASON</span><br />{{Model.Reason}}</div>
                </div>

                <div class="row" *ngIf="Model.LastActionRemarks">
                    <div class="col"><span class="lblDisplay linebreak"
                            translate>LBL.LAST_REMARK</span><br />{{Model.LastActionRemarks}}</div>
                </div>
            </div>

            <div class="subSection" *ngIf="Model.LastRemarks">
                <div class="row">
                    <div class="col"><span class="lblDisplay linebreak"
                            translate>LBL.REG_REMARK</span><br />{{Model.LastRemarks}}</div>
                </div>
            </div>

            <div class="subSection" *ngIf="workOrderRemarks">
                <div class="row">
                    <div class="col"><span class="lblDisplay linebreak"
                            translate>LBL.NOTES</span><br />{{workOrderRemarks}}</div>
                </div>
            </div>

             <div class="subSection" *ngIf="inventorySingularityEnabled && JobInventoryDetail" >
                <div class="row">
                    <div class="col-4">
                    <span class="lblDisplay" translate>LBL.LBL_INV_ITEM_NAME</span><br />
                    {{JobInventoryDetail.Name}}
                    </div>
                    <div class="col-8">
                    <span class="lblDisplay" translate>LBL.LBL_INV_CAT</span><br />
                    {{JobInventoryDetail.ItemType}}
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">
                    <span class="lblDisplay" translate>LBL.QUANTITY</span><br />
                    {{JobInventoryDetail.DefaultQuantity}}
                    </div>
                     <div class="col-8"  *ngIf="(inventoryItempType == InventoryItemType.Reusable || inventoryItempType == InventoryItemType.Consumables ) && Model.CurrentStatus === _CallStatuses.Close && JobInventoryDetail.StockLocationName">
                        <span class="lblDisplay" translate>LBL.LBL_STORE_LOCATION</span><br />
                        {{JobInventoryDetail.StockLocationName}}
                    </div>
                </div>

                <div *ngIf="inventoryItempType == InventoryItemType.Reusable && Model.CurrentStatus === _CallStatuses.Close" class="row">
                    <div class="col-4" *ngIf="JobInventoryDetail && JobInventoryDetail.InventoryCheckInAt">
                        <span class="lblDisplay" translate>LBL.LBL_INV_UTILIZED_FROM</span><br />
                        {{
                            JobInventoryDetail.InventoryCheckInAt | amDateFormat: DateFormat
                        }}
                    </div>
                    <div class="col-8" *ngIf="JobInventoryDetail && JobInventoryDetail.InventoryCheckOutAt">
                        <span class="lblDisplay" translate>LBL.LBL_INV_UTILIZED_TILL</span><br />
                        {{
                            JobInventoryDetail.InventoryCheckOutAt  | amDateFormat: DateFormat
                        }}
                    </div>
                </div>

                <div *ngIf="JobInventoryDetail && JobInventoryDetail.Message" class="row">
                    <div class="col-12">
                        <span class="lblDisplay" translate>LBL.LBL_MESSAGE</span><br />
                    <span *ngIf="JobInventoryDetail.Message == '200' && JobInventoryDetail.TransactionType ==  InventoryTransactionTypes.Consume"> {{ 'LBL.LBL_SUCCESS_INVENTORY_CONSUMED' | translate }}  </span>
                    <span *ngIf="JobInventoryDetail.Message == '200' && JobInventoryDetail.TransactionType ==  InventoryTransactionTypes.Reserve"> {{ 'LBL.LBL_SUCCESS_INVENTORY_RESERVED' | translate }}  </span>
                    <span *ngIf="JobInventoryDetail.Message == '500'"> {{ 'ERR.ERR_INVENTORY_SERVER' | translate }}  </span>
                    <span *ngIf="JobInventoryDetail.Message == '400'"> {{ 'ERR.ERR_INVENTORY_UNAVAILABLE' | translate }}  </span>
                    </div>
                </div>
        </div>

            <div class="subSection section_Attachment callAttachment">
                <h4 class="d-flex justify-content-between border-bottom align-items-baseline"><span
                        translate>LBL.ATTACHMENTS</span> <button
                        *ngIf="Mode != _JobPopoverMode.ReadOnly && Model.IsControlWithKSV && Model.CurrentStatus != _CallStatuses.Close && (CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.CallAttachment_ADD))"
                        class="btn btn-secondary mb-2" type="button"
                        (click)="callAttachment.Open(UpdateModel)">{{'BTN.BTN_ADD_ATTACHMENTS' | translate}}</button>
                </h4>
                <div class="row" *ngIf="Model.Attachments == null || Model.Attachments.length == 0">
                    <div class="col"><span translate>LBL.NO_ATTACHMENT</span></div>
                </div>
                <div class="row" *ngIf="Model.Attachments && Model.Attachments.length > 0">
                    <div class="col-6 mb-3" *ngFor="let row of Model.Attachments; let idx = index;">
                        <div class="pointer">
                            <ng-container *ngIf="!row.IsWorkOrder">
                            <div *ngIf="row.CallRegAttachmentId && row.CallRegAttachmentId <= 0"><img
                                    class="img-thumbnail imgPreview"
                                    [src]="_sanitizer.bypassSecurityTrustUrl('' + row.Base64String)" /></div>
                            <a target="_blank"
                                *ngIf="row.CallRegAttachmentId && row.CallRegAttachmentId > 0 && _MasterConstants.IsImage(row.FileName)"
                                href="/Pages/Complain_GetAttachmentStream?CallRegAttachmentId={{row.CallRegAttachmentId}}&Size=1"><img
                                    class="img-thumbnail imgPreview"
                                    src="/Pages/Complain_GetAttachmentStream?CallRegAttachmentId={{row.CallRegAttachmentId}}&Size=3" /></a>
                            <a target="_blank"
                                class="img-thumbnail imgPreview  d-flex align-items-center justify-content-center"
                                *ngIf="row.CallRegAttachmentId && row.CallRegAttachmentId > 0 && _MasterConstants.IsImage(row.FileName) == false"
                                href="/Pages/Complain_GetAttachmentStream?CallRegAttachmentId={{row.CallRegAttachmentId}}"><img
                                    class="" src="/Assets/FileIcons/48px/{{GetFileExtension(row.FileName)}}.png" /></a>
                            </ng-container>
                            <ng-container *ngIf="row.IsWorkOrder">
                            <a target="_blank" *ngIf="row.FileUrl && _MasterConstants.IsImage(row.FileName)"
                                href="{{row.FileUrl}}"><img
                                    class="img-thumbnail imgPreview"
                                    src="{{row.FileUrl}}" /></a>
                            <a target="_blank"
                                class="img-thumbnail imgPreview  d-flex align-items-center justify-content-center"
                                *ngIf="row.FileUrl && _MasterConstants.IsImage(row.FileName) == false"
                                href="{{row.FileUrl}}"><img
                                    class="" src="/Assets/FileIcons/48px/{{GetFileExtension(row.FileName)}}.png" /></a>
                            </ng-container>
                        </div>
                        <div>{{row.FileName}}</div>
                        <div><button
                                *ngIf="Mode != _JobPopoverMode.ReadOnly && Model.IsControlWithKSV && Model.CurrentStatus != _CallStatuses.Close && (CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.CallAttachment_DELETE))"
                                class="btn btn-link p-0" (click)="onDeleteAttachment(row)"
                                translate>BTN.BTN_DELETE</button></div>
                    </div>
                </div>
            </div>

            <div *ngIf="(Model.IsAudited) && CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.CallGSRAudit)"
                class="subSection">
                <h4 [hidden]="!GSRAuditData" translate>LBL.GSR_AUDIT</h4>
                <table class="table table-bordered" [hidden]="!GSRAuditData">
                    <thead>
                        <tr class="col-auto">
                            <th translate>LBL.GSR_DATE</th>
                            <th translate>LBL.PERFORMED_BY</th>
                            <th>{{'LBL.Q' | translate}}1</th>
                            <th>{{'LBL.Q' | translate}}2</th>
                            <th>{{'LBL.Q' | translate}}3</th>
                            <th>{{'LBL.Q' | translate}}4</th>
                            <th>{{'LBL.Q' | translate}}5</th>
                            <th translate>LBL.AVG_GSR</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of GSRAuditData" class="col-auto">
                            <td>{{row.AuditDate | amDateFormat: DateFormat}}</td>
                            <td>{{row.AuditorName}}</td>
                            <td>{{row.Q1wt}}</td>
                            <td>{{row.Q2wt}}</td>
                            <td>{{row.Q3wt}}</td>
                            <td>{{row.Q4wt}}</td>
                            <td>{{row.Q5wt}}</td>
                            <td>{{row.Rating}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="subSection section_History">
                <div class="row border-bottom mb-3">
                    <div class="col-auto">
                        <h4><span translate>LBL.JOB_HISTORY</span></h4>
                    </div>
                    <div class="col-auto ml-auto">
                        <div class="ml-2" *ngIf="HistoryData && HistoryData.ComplainHistory.length > 0">
                            <ngb-pagination [collectionSize]="HistoryData.ComplainHistory.length"
                                [pageSize]="HistoryPageSize" [(page)]="HistoryPageNumber" [boundaryLinks]="true"
                                size="sm"></ngb-pagination>
                        </div>
                    </div>
                </div>

                <sk-wave [isRunning]="IsSubmitting"></sk-wave>

                <ul class="list-unstyled" *ngIf="IsSubmitting == false && HistoryData">
                    <li class="row historyItem"
                        *ngFor="let row of HistoryData.ComplainHistory | slice: (HistoryPageNumber-1) * HistoryPageSize : (HistoryPageNumber-1) * HistoryPageSize + HistoryPageSize">
                        <div class="col-3">
                            {{row.ActionTime | amDateFormat: DateFormat}}
                            <div class="text-muted small">{{row.LoggedByName}}</div>
                        </div>
                        <div class="col">
                            <div class="d-flex historyStatus justify-content-between">
                                <div class="badge badge-secondary font-weight-bold">{{row.ActionName | translate}}</div>
                                <div><span class="statusIcon-{{row.Status}}">{{row.StatusName}}&nbsp;<i
                                            class="fas fa-circle"></i> </span></div>
                            </div>
                            <div>{{row.AssignedStaffName}}</div>
                            <div *ngIf="row.ReasonId">{{row.ReasonName}}</div>
                            <div class="linebreak">{{row.Remarks}}</div>
                            <div *ngIf="row.AttachmentName">{{row.AttachmentName}}</div>

                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</div>

<ManualAssign #manualAssign [Mode]="_JobOperationActions.ReAssign" [RequestModel]="Model"
    (SelectedStaffChanged)="onSelectedStaff($event)"></ManualAssign>
<GSRAudit #gsrAudit></GSRAudit>
<JobOperations #jobOperations></JobOperations>
<CallAttachment #callAttachment (AttachmentChanged)="onAttachmentChanged($event)" [OnlyNew]="true"></CallAttachment>
<TagStaff #tagStaff></TagStaff>
<SendMsg #sendMsg></SendMsg>
